import { forwardRef, type SelectHTMLAttributes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { cn } from '../utils/cn';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

const BASE =
  'block w-full appearance-none rounded-md border border-hilevel-border bg-white px-3 py-2 pr-9 text-sm text-hilevel-slate focus:outline-none focus:ring-2 focus:ring-hilevel-red/30 focus:border-hilevel-red transition';

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, children, ...rest },
  ref,
) {
  return (
    <div className="relative">
      <select ref={ref} className={cn(BASE, className)} {...rest}>
        {children}
      </select>
      <FontAwesomeIcon
        icon={faChevronDown}
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-hilevel-gray"
      />
    </div>
  );
});
